export const SET_LOYALTY_MSRP_DISCOUNTS = 'SET_LOYALTY_MSRP_DISCOUNTS';
export const SET_IS_LOYALTY_DATA_UPDATED = 'SET_IS_LOYALTY_DATA_UPDATED';
export const UPDATED_LOYALTY_MSRP_DISCOUNTS = 'UPDATED_LOYALTY_MSRP_DISCOUNTS';
export const SET_OFFER_FILTER = 'SET_OFFER_FILTER';
export const UPDATED_OFFER_FILTER = 'UPDATED_OFFER_FILTER';
export const SET_COPY_DISCOUNTS = 'SET_COPY_DISCOUNTS';
export const SET_SELECTED_TAB = 'SET_SELECTED_TAB';
